var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("确认收货")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-3" }, [
        _vm.goodsShipVoucher.orderFlag
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "form-value width-1-5x" }, [
                _c("span", [_vm._v(_vm._s(_vm.goodsShipVoucher.orderNo))])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsShipVoucher.no))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsShipVoucher.senderComName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsShipVoucher.senderContactName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsShipVoucher.senderContactTel))])
          ])
        ]),
        _vm._v(" "),
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(7),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.goodsShipVoucher.driverName || ""))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(8),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.goodsShipVoucher.driverMobile || ""))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(9),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.goodsShipVoucher.vehicleLsnNo || ""))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(10),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _vm.goodsShipVoucher.amount != null
              ? _c("span", [
                  _vm._v(
                    _vm._s(_vm.goodsShipVoucher.amount.toFixed(2) || "0.00")
                  )
                ])
              : _c("span", [_vm._v("0.00")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(11),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.goodsShipVoucher.logisFee || "0.00"))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(12),
      _vm._v(" "),
      _vm._m(13),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-form",
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.goodsShipItemList,
                    border: "",
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _vm.showAssetInfo
                    ? _c(
                        "el-table-column",
                        { attrs: { align: "center", label: "资产信息" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              width: "130",
                              prop: "devcName",
                              label: "名称",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              width: "100",
                              prop: "devcCatName",
                              label: "分类",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              width: "100",
                              prop: "devcBrandName",
                              label: "品牌",
                              "show-overflow-tooltip": ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showAssetInfo
                    ? _c(
                        "el-table-column",
                        { attrs: { align: "center", label: "商品信息" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              width: "130",
                              prop: "title",
                              label: "名称",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              width: "100",
                              prop: "catName",
                              label: "分类",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "left",
                              width: "100",
                              prop: "brandName",
                              label: "品牌",
                              "show-overflow-tooltip": ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "130",
                          prop: "title",
                          label: "名称",
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "100",
                          prop: "catName",
                          label: "分类",
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showAssetInfo
                    ? _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "100",
                          prop: "brandName",
                          label: "品牌",
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      width: "160",
                      label: "需要供应商提供唯一标识码"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.vendorUknoFlag
                              ? _c("span", [_vm._v("是")])
                              : _c("span", [_vm._v("否")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      width: "60",
                      prop: "asmblAccFlag",
                      label: "组装件"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.asmblAccFlag
                              ? _c("span", [_vm._v("是")])
                              : _c("span", [_vm._v("否")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "130",
                      prop: "price",
                      label: "价格(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.price != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.price.toFixed(2)))
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "60",
                      prop: "taxRate",
                      label: "税率(%)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.taxRate != null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(rows.row.taxRate.toFixed(2) || 0.0)
                                  )
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "130",
                      prop: "ntxPrice",
                      label: "未税价(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.ntxPrice != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.ntxPrice.toFixed(2)))
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "130",
                      prop: "amount",
                      label: "费用小计(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.amount != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.amount.toFixed(2)))
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "80",
                      prop: "quantity",
                      label: "发货数量",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.quantity != null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.quantity -
                                        scope.row.offsetQuantity
                                    )
                                  )
                                ])
                              : _c("span", [_vm._v("0")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "80",
                      prop: "surplusQuantity",
                      label: "待收货数量",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "80",
                      prop: "recvQuantity",
                      label: "收货数量",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "goodsShipItemList." +
                                    scope.$index +
                                    ".recvQuantity"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "text-right",
                                  attrs: { type: "text" },
                                  on: {
                                    change: function($event) {
                                      _vm.quantityChange(scope.row)
                                    }
                                  },
                                  model: {
                                    value: scope.row.recvQuantity,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "recvQuantity", $$v)
                                    },
                                    expression: "scope.row.recvQuantity"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      width: "140",
                      prop: "batchNo",
                      label: "批次号",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "goodsShipItemList." +
                                    scope.$index +
                                    ".batchNo"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { type: "text" },
                                  model: {
                                    value: scope.row.batchNo,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "batchNo", $$v)
                                    },
                                    expression: "scope.row.batchNo"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "rescDesc",
                      label: "描述",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "goodsShipItemList." +
                                    scope.$index +
                                    ".desc"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { type: "textarea" },
                                  model: {
                                    value: scope.row.rescDesc,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "rescDesc", $$v)
                                    },
                                    expression: "scope.row.rescDesc"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "simple-form" },
        [
          _c(
            "el-form",
            {
              ref: "arriveDate",
              staticClass: "demo-ruleForm",
              attrs: { model: _vm.goodsRecvVoucher, rules: _vm.validateRules }
            },
            [
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [_vm._v("标题")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-1-5x" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "title" } },
                      [
                        _c("el-input", {
                          attrs: { type: "text", placeholder: "请输入标题" },
                          model: {
                            value: _vm.goodsRecvVoucher.title,
                            callback: function($$v) {
                              _vm.$set(_vm.goodsRecvVoucher, "title", $$v)
                            },
                            expression: "goodsRecvVoucher.title"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.goodsRecvVoucher.exceptional
                ? _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", { staticClass: "required" }, [
                        _vm._v("异常描述")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-value width-1-5x" },
                      [
                        _c("el-input", {
                          staticClass: "width-2x",
                          attrs: {
                            type: "textarea",
                            rows: 3,
                            placeholder: "请输入",
                            maxlength: 120
                          },
                          model: {
                            value: _vm.goodsRecvVoucher.exceptionDesc,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.goodsRecvVoucher,
                                "exceptionDesc",
                                $$v
                              )
                            },
                            expression: "goodsRecvVoucher.exceptionDesc"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("要求到货日期")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-1-5x" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "dueArriveDate" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.goodsRecvVoucher.dueArriveDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.goodsRecvVoucher,
                                  "dueArriveDate",
                                  $$v
                                )
                              },
                              expression: "goodsRecvVoucher.dueArriveDate"
                            }
                          },
                          _vm._l(_vm.desireArriveDate, function(value, key) {
                            return _c("el-option", {
                              key: value,
                              attrs: { label: value, value: value }
                            })
                          })
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [
                    _vm._v("实际到货日期")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-1-5x" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "actualArriveDate" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            "picker-options": _vm.pickerOptions0,
                            type: "date",
                            placeholder: "选择日期"
                          },
                          model: {
                            value: _vm.goodsRecvVoucher.actualArriveDate,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.goodsRecvVoucher,
                                "actualArriveDate",
                                $$v
                              )
                            },
                            expression: "goodsRecvVoucher.actualArriveDate"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.autoInStock
                ? [
                    _c("div", { staticClass: "input-tip error" }, [
                      _c("span", [_vm._v("提示:确认收货后、将自动生成验收单")])
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.autoInStock
                ? _c("div", { staticClass: "input-tip error" }, [
                    _c("span", [
                      _vm._v(
                        "提示:未开启自动验收入库业务参数，确认收货后，需手动验收入库"
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.autoInStock && _vm.showBizUnitWarehouse
                ? _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", { staticClass: "required" }, [
                        _vm._v("入库仓库")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-value width-1-5x" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "warehouseId" } },
                          [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: _vm.warehouseId,
                                  callback: function($$v) {
                                    _vm.warehouseId = $$v
                                  },
                                  expression: "warehouseId"
                                }
                              },
                              _vm._l(_vm.warehouseList, function(item) {
                                return _c("el-option", {
                                  attrs: { label: item.name, value: item.id }
                                })
                              })
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.autoInStock
                ? _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", [_vm._v(" ")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-value width-1-5x" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "autoReceive" } },
                          [
                            _c(
                              "el-checkbox",
                              {
                                on: { change: _vm.changeAutoReceive },
                                model: {
                                  value: _vm.autoReceive,
                                  callback: function($$v) {
                                    _vm.autoReceive = $$v
                                  },
                                  expression: "autoReceive"
                                }
                              },
                              [_vm._v("机构负责人自动领用")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("swb-recv-file-edit", {
        ref: "swb_recv_file_edit",
        attrs: { edit: true }
      }),
      _vm._v(" "),
      _vm.goodsShipVoucher.shipVoucherFileList != null &&
      _vm.goodsShipVoucher.shipVoucherFileList.length > 0
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("发货附件")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.goodsShipVoucher.shipVoucherFileList != null &&
      _vm.goodsShipVoucher.shipVoucherFileList.length > 0
        ? _c(
            "div",
            { staticClass: "file-view-list" },
            [
              _vm._m(14),
              _vm._v(" "),
              _vm._l(_vm.goodsShipVoucher.shipVoucherFileList, function(
                fileInfo,
                index
              ) {
                return [
                  _c("swb-file-item-li", {
                    attrs: {
                      trackKey: index,
                      fileName: fileInfo.name,
                      fileBrowseUrl: fileInfo.fileBrowseUrl,
                      fileDownloadUrl: fileInfo.fileBrowseUrl,
                      fileUuid: fileInfo.fileUuid,
                      deletable: false
                    }
                  })
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-toolbar align-center",
          staticStyle: { padding: "0" }
        },
        [
          _c(
            "button",
            {
              staticClass: "swb-btn swb-btn-small",
              on: {
                click: function($event) {
                  _vm.saveGoodsRecvVoucher()
                }
              }
            },
            [_vm._v("确认")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("单据信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("订单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发货单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发货机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发货人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发货人联系方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group center" }, [
      _c("div", { staticClass: "form-label" }, [_c("label", [_vm._v(" ")])]),
      _vm._v(" "),
      _c("div", { staticClass: "form-value width-1-5x" }, [_c("span")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("司机姓名")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("司机电话")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("车辆牌号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("商品总费用(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("物流费用(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("商品信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb15" }, [
      _c("span", { staticClass: "font-red" }, [
        _vm._v(
          "*温馨提示：1.如发货数量有误，可联系发货方调整数量。2.确认收货时，组装件自动入库。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file-view-header" }, [
      _c("div", { staticClass: "file-name" }, [_vm._v("名称")]),
      _vm._v(" "),
      _c("div", { staticClass: "file-opera" }, [_vm._v("操作")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e653d612", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e653d612","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsRecvVoucherSure.vue
// module id = 2953
// module chunks = 0